import { useState, useMemo } from "react";
import { formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";

export default function FARCalculator() {
  const [area, setArea] = useState("2400");
  const [far, setFar] = useState("2.5");
  const [coverage, setCoverage] = useState("60");

  const { builtup, ground, remaining, floors } = useMemo(() => {
    const A = Number(area) || 0;
    const F = Number(far) || 0;
    const C = (Number(coverage) || 0) / 100;
    const built = A * F;
    const ground = A * C;
    return {
      builtup: built,
      ground,
      remaining: Math.max(0, A - ground),
      floors: ground > 0 ? built / ground : 0,
    };
  }, [area, far, coverage]);

  const rows = [
    ["Plot Area", `${formatNumber(Number(area)||0)} sq ft`],
    ["Allowed FAR / FSI", far],
    ["Ground Coverage", `${coverage}%`],
    ["Maximum Built-up Area", `${formatNumber(builtup)} sq ft`],
    ["Ground Coverage Area", `${formatNumber(ground)} sq ft`],
    ["Open Area", `${formatNumber(remaining)} sq ft`],
    ["Approx floors possible", formatNumber(floors, 2)],
  ];

  return (
    <div>
      <CalcPageHeader title="FAR / FSI Calculator" description="Maximum built-up area & ground coverage on a plot under given FAR / FSI norms." slug="far" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 space-y-4">
            <Field label="Plot Area (sq ft)"><input data-testid="far-area" type="number" value={area} onChange={(e)=>setArea(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <div className="grid grid-cols-2 gap-4">
              <Field label="Allowed FAR"><input data-testid="far-value" type="number" step="0.1" value={far} onChange={(e)=>setFar(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
              <Field label="Ground Coverage %"><input data-testid="far-coverage" type="number" value={coverage} onChange={(e)=>setCoverage(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            </div>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="FAR / FSI" slug="far" highlight={{ label: "Max Built-up Area", value: `${formatNumber(builtup)} ft²` }} rows={rows} note="Check local development authority for exact FAR / FSI, setback and coverage norms." onReset={()=>{setArea("");}} />
        </div>
      </div>
    </div>
  );
}
